import { useEffect, useState } from "react";
import { API } from "./api";
import {
  TextField, Select, MenuItem,
  Card, CardContent, Typography,
  Grid, Table, TableHead,
  TableRow, TableCell, TableBody,
  Button, Paper, Dialog,
  DialogTitle, DialogContent,
  DialogActions
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusinessIcon from "@mui/icons-material/Business";
import AppsIcon from "@mui/icons-material/Apps";
import PublicIcon from "@mui/icons-material/Public";

const styles = `
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;

export default function Dashboard({
  filterApp,
  filterEnv,
  filterClient,
  filterDeveloper,
  setSelectedEnv,
  setSelectedApp,     // ✅ ADD
  setSelectedClient,  // ✅ ADD
  setPage,
  llmOnly
}) {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const appsPerPage = 10;
  const [search, setSearch] = useState("");
  const [env, setEnv] = useState("");
  const [cloud, setCloud] = useState("");

  const [editApp, setEditApp] = useState(null);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [allApps, setAllApps] = useState([]);


  const role = localStorage.getItem("role");

  const fetchAllApps = async () => {
  try {
    const res = await API.get(`/apps`);  // ✅ FIXED

    console.log("ALL APPS API RESPONSE:", res.data);

    let data = [];

    if (Array.isArray(res.data)) {
      data = res.data;
    } else if (Array.isArray(res.data.data)) {
      data = res.data.data;
    } else if (Array.isArray(res.data.apps)) {
      data = res.data.apps;
    }

    console.log("FINAL DATA:", data);

    setAllApps(data);   // ✅ ONLY ONCE

  } catch (err) {
    console.error("API ERROR:", err);
    setAllApps([]);
  }
};

  const fetchApps = async () => {
  const res = await API.get(`/apps`);
  let data = res.data.data || res.data || [];

  setApps(data);   // ✅ ONLY THIS
};



  useEffect(() => {
  fetchApps();
  fetchAllApps();
}, []);   // ✅ REMOVE DEPENDENCIES


  // ✅ Reset page on filter/search
useEffect(() => {
  setCurrentPage(1);
}, [search, env, cloud, filterApp, filterEnv, filterClient, filterDeveloper]);

const getBaseUrl = (url) => {
  try {
    return new URL(url).origin;
  } catch {
    return url;
  }
};

// ✅ FIRST define baseApps
const baseApps =
  (apps && apps.length > 0) &&
  (filterApp || filterEnv || filterClient || filterDeveloper || llmOnly)
    ? apps.filter((app) => {
        return (
          (filterApp ? app.app_name === filterApp : true) &&
          (filterEnv
  ? (app.environment || "").trim().toLowerCase() === filterEnv.trim().toLowerCase()
  : true) &&
          (filterClient
  ? (app.client || "").trim().toLowerCase() === filterClient.trim().toLowerCase()
  : true) &&
          (filterDeveloper
            ? (app.developer || "")
                .toLowerCase()
                .includes(filterDeveloper.toLowerCase())
            : true) &&
            (llmOnly === true
  ? (app.module || "").toLowerCase().startsWith("llm")
  : true)
        );
      })
    : apps;

// ✅ MAIN FILTER (SEARCH + EXISTING FILTERS)
const filtered = baseApps.filter((a) =>
  // 🔍 GLOBAL SEARCH (SAFE VERSION)
  (search
    ? (
        (a.app_name || "") +
        (a.client || "") +
        (a.module || "") +
        (a.environment || "") +
        (a.repo_name || "") +
        (a.developer || "") +
        (a.url || "") +
        (a.cloud || "") +
        (a.server_name || "")
      )
        .toLowerCase()
        .includes(search.toLowerCase())
    : true) &&

  // EXISTING FILTERS (NO CHANGE)
  (env ? a.environment === env : true) &&
  (cloud
    ? (a.cloud || "").toLowerCase().includes(cloud.toLowerCase())
    : true)
);

// ✅ ADD THIS LINE HERE (VERY IMPORTANT)
useEffect(() => {
  setTotalPages(Math.ceil(filtered.length / appsPerPage));
}, [filtered, appsPerPage]);

// ✅ SERVER UNIQUE LOGIC (NO CHANGE)
const uniqueServers = Object.values(
  baseApps.reduce((acc, app) => {
    let key = app.server_name?.trim().toLowerCase();

    if (!key) {
      try {
        key = new URL(app.url).hostname.toLowerCase();
      } catch {
        key = app.url?.toLowerCase();
      }
    }

    if (!key) return acc;

    if (!acc[key]) acc[key] = app;

    return acc;
  }, {})
);

 const getUniqueEnvCount = (envName) => {
  const map = new Set();

  baseApps.forEach((app) => {
    if (app.environment === envName) {
      try {
        const base = app.app_name + "_" + new URL(app.url).origin;
map.add(base);
      } catch {
        // ignore invalid URLs
      }
    }
  });

  return map.size;
};


  const envStats = [
  { title: "Total", value: new Set(baseApps.map(a => {
      try { return new URL(a.url).origin } catch { return null }
    }).filter(Boolean)).size, color: "#3b82f6" },

  { title: "PROD", value: getUniqueEnvCount("PROD"), color: "#ef4444" },

  { title: "DEV", value: getUniqueEnvCount("DEV"), color: "#10b981" },

  { title: "UAT", value: getUniqueEnvCount("UAT"), color: "#f59e0b" },

  { title: "DEMO", value: getUniqueEnvCount("DEMO"), color: "#6366f1" },

  { title: "POC", value: getUniqueEnvCount("POC"), color: "#14b8a6" }
];
  const cloudStats = [
  { title: "Total Servers", value: uniqueServers.length, color: "#0ea5e9" },

  {
    title: "AWS-Mindpro",
    value: uniqueServers.filter(a =>
      a.cloud?.toLowerCase().includes("aws") &&
      a.cloud?.toLowerCase().includes("mindpro")
    ).length,
    color: "#f97316"
  },

  {
    title: "On-Prem-Mindpro",
    value: uniqueServers.filter(a =>
      a.cloud?.toLowerCase().includes("on-prem") &&
      a.cloud?.toLowerCase().includes("mindpro")
    ).length,
    color: "#16a34a"
  },

  {
    title: "AWS-Matrix",
    value: uniqueServers.filter(a =>
      a.cloud?.toLowerCase().includes("aws") &&
      a.cloud?.toLowerCase().includes("matrix")
    ).length,
    color: "#facc15"
  },

  {
    title: "On-Prem-Matrix",
    value: uniqueServers.filter(a =>
      a.cloud?.toLowerCase().includes("on-prem") &&
      a.cloud?.toLowerCase().includes("matrix")
    ).length,
    color: "#22c55e"
  },

  {
    title: "AZURE",
    value: uniqueServers.filter(a =>
    (a.cloud || "").toLowerCase().startsWith("azure")
    ).length,
    color: "#2563eb"
  },

  {
    title: "GoDaddy",
    value: uniqueServers.filter(a =>
    (a.cloud || "").toLowerCase().includes("godaddy")
    ).length,
    color: "#9333ea"
  },

  {
    title: "Apple-Mac",
    value: uniqueServers.filter(a =>
    (a.cloud || "").toLowerCase().includes("apple-mac")
    ).length,
    color: "#0f172a"
  }
];

  const validate = () => {
  if (!editApp?.app_name) return "App Name required";
  if (!editApp?.environment) return "Environment required";
  if (!editApp?.url) return "URL required";
  return null;
};

  const handleEdit = (app) => {
    if (role !== "admin") return;
    setEditApp({ ...app });
    setOpen(true);
    setMessage("");
  };

  const handleSave = async () => {
    const error = validate();
    if (error) {
      setMessage("❌ " + error);
      return;
    }

    try {
      await API.put(`/apps/${editApp.id}`, editApp);
      setMessage("✅ Updated Successfully");
      setOpen(false);
      fetchAllApps();  // ✅ REFRESH ALL APPS
      fetchApps();
    } catch {
      setMessage("❌ Update failed");
    }
  };

  const handleDelete = async (id) => {
    if (role !== "admin") return;
    if (!window.confirm("Are you sure you want to delete?")) return;

    try {
      await API.delete(`/apps/${id}`);
      setMessage("🗑 Deleted successfully");
      fetchAllApps();
      fetchApps();
    } catch {
      setMessage("❌ Delete failed");
    }
  };

  return (
  <div style={{ animation: "fadeIn 0.4s ease-in-out" }}>
    <style>{styles}</style>

{/* 📍 BREADCRUMB */}
<div style={{
  marginBottom: 10,
  fontWeight: "bold",
  display: "flex",
  alignItems: "center",
  gap: 6
}}>

  {/* CLIENT */}
  {filterClient && (
    <span
      style={{
        cursor: "pointer",
        color: "#2563eb",
        display: "flex",
        alignItems: "center",
        gap: 4
      }}
      onClick={() => {
        setSelectedApp && setSelectedApp(null);
        setSelectedEnv && setSelectedEnv(null);
      }}
    >
      <BusinessIcon fontSize="small" />
      {filterClient}
    </span>
  )}

  {/* APP */}
  {(filterClient || filterApp || filterEnv) && (
    <>
      <span>›</span>
      <span
        style={{
          cursor: "pointer",
          color: "#16a34a",
          display: "flex",
          alignItems: "center",
          gap: 4
        }}
        onClick={() => {
          setSelectedEnv && setSelectedEnv(null);
        }}
      >
        <AppsIcon fontSize="small" />
        {filterApp}
      </span>
    </>
  )}

  {/* ENV */}
  {filterEnv && (
    <>
      <span>›</span>
      <span style={{
        color: "#f59e0b",
        display: "flex",
        alignItems: "center",
        gap: 4
      }}>
        <PublicIcon fontSize="small" />
        {filterEnv}
      </span>
    </>
  )}

</div>

      {/* ENV CARDS */}
      <Grid container spacing={3}>
        {envStats.map((item, i) => (
          <Grid item xs={2} key={i}>
            <Card
              onClick={() => {
                if (filterApp && item.title !== "Total" && setSelectedEnv) {
                  setSelectedEnv(item.title);
                  setPage("envDetail");
                }
              }}
              style={{
                borderRadius: 12,
                cursor: filterApp ? "pointer" : "default",
                background: `linear-gradient(135deg, ${item.color}, #1e293b)`,
                color: "white"
              }}
            >
              <CardContent>
                <Typography>{item.title}</Typography>
                <Typography variant="h4">{item.value}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* CLOUD CARDS */}
      <Grid container spacing={3} style={{ marginTop: 10 }}>
        {cloudStats.map((item, i) => (
          <Grid item xs={2} key={i}>
            <Card style={{
              borderRadius: 12,
              background: `linear-gradient(135deg, ${item.color}, #1e293b)`,
              color: "white"
            }}>
              <CardContent>
                <Typography>{item.title}</Typography>
                <Typography variant="h5">{item.value}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* FILTER */}
      <Paper style={{ marginTop: 20, padding: 20 }}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <TextField fullWidth label="Search..." onChange={(e) => setSearch(e.target.value)} />
          </Grid>

          <Grid item xs={3}>
            <Select fullWidth value={env} onChange={(e) => setEnv(e.target.value)} displayEmpty>
              <MenuItem value="">All Env</MenuItem>
              <MenuItem value="DEV">DEV</MenuItem>
              <MenuItem value="UAT">UAT</MenuItem>
              <MenuItem value="PROD">PROD</MenuItem>
              <MenuItem value="DEMO">DEMO</MenuItem>
              <MenuItem value="POC">POC</MenuItem>
            </Select>
          </Grid>

          <Grid item xs={3}>
            <Select fullWidth value={cloud} onChange={(e) => setCloud(e.target.value)} displayEmpty>
              <MenuItem value="">All Cloud</MenuItem>
              <MenuItem value="AWS-Mindpro">AWS-Mindpr (A/C)</MenuItem>
              <MenuItem value="AZURE">AZURE</MenuItem>
              <MenuItem value="On-Prem-Mindpro">On-Prem-Mindpro</MenuItem>
              <MenuItem value="GoDaddy">GoDaddy</MenuItem>
              <MenuItem value="Apple-Mac">Apple-Mac</MenuItem>
              <MenuItem value="AWS-Matrix">AWS-Matrix (A/C)</MenuItem>
              <MenuItem value="On-Prem-Matrix">On-Prem-Matrix</MenuItem>
            </Select>
          </Grid>
        </Grid>
      </Paper>

      {loading && (
  <div style={{ textAlign: "center", padding: 20 }}>
    ⏳ Loading...
  </div>
)}

      {/* TABLE */}
      <Paper style={{ marginTop: 20 }}>
        <Table>
          <TableHead style={{ background: "#1e3a8a" }}>
            <TableRow>
              <TableCell style={{ color: "white" }}>App</TableCell>
              <TableCell style={{ color: "white" }}>Client</TableCell>
              <TableCell style={{ color: "white" }}>Module</TableCell>
              <TableCell style={{ color: "white" }}>Env</TableCell>
              <TableCell style={{ color: "white" }}>Repo</TableCell>
              <TableCell style={{ color: "white" }}>Developer</TableCell>
              <TableCell style={{ color: "white" }}>URL</TableCell>
              <TableCell style={{ color: "white" }}>Cloud</TableCell>
              <TableCell style={{ color: "white" }}>Server</TableCell>
              <TableCell style={{ color: "white" }}>Pipeline</TableCell>
              <TableCell style={{ color: "white" }}>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filtered
              .slice((currentPage - 1) * appsPerPage, currentPage * appsPerPage)
              .map((app) => (
              <TableRow key={app.id}>
                <TableCell>{app.app_name}</TableCell>
                <TableCell>{app.client}</TableCell>
                <TableCell>{app.module}</TableCell>
                <TableCell>{app.environment}</TableCell>
                <TableCell>{app.repo_name}</TableCell>
                <TableCell>{app.developer}</TableCell>
                <TableCell>
                  <a href={app.url} target="_blank" rel="noreferrer">{app.url}</a>
                </TableCell>
                <TableCell>{app.cloud}</TableCell>
                <TableCell>{app.server_name}</TableCell>
                <TableCell>
                  {app.jenkins_pipeline?.startsWith("http") ? (
                    <a href={app.jenkins_pipeline} target="_blank" rel="noreferrer">🔗 Open</a>
                  ) : app.jenkins_pipeline}
                </TableCell>
                <TableCell>
                  {role === "admin" && (
                    <>
                      <Button size="small" variant="contained" onClick={() => handleEdit(app)}>Edit</Button>
                      <Button size="small" color="error" onClick={() => handleDelete(app.id)}>Delete</Button>
                    </>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <div style={{
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  padding: 10
}}>

  {/* PREV BUTTON */}
  <Button
    size="small"
    disabled={currentPage === 1}
    onClick={() => setCurrentPage((prev) => prev - 1)}
    style={{ marginRight: 8 }}
  >
    Prev
  </Button>

  {/* PAGE NUMBERS (LIMITED) */}
  {Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter((page) =>
      page === 1 ||
      page === totalPages ||
      (page >= currentPage - 2 && page <= currentPage + 2)
    )
    .map((page, index, arr) => (
      <span key={page}>
        {/* DOTS */}
        {index > 0 && page - arr[index - 1] > 1 && (
          <span style={{ margin: "0 5px" }}>...</span>
        )}

        <Button
          size="small"
          variant={currentPage === page ? "contained" : "outlined"}
          onClick={() => setCurrentPage(page)}
          style={{ margin: "0 3px" }}
        >
          {page}
        </Button>
      </span>
    ))}

  {/* NEXT BUTTON */}
  <Button
    size="small"
    disabled={currentPage === totalPages}
    onClick={() => setCurrentPage((prev) => prev + 1)}
    style={{ marginLeft: 8 }}
  >
    Next
  </Button>

</div>

      </Paper>

      {/* MESSAGE */}
      {message && (
        <div style={{
          position: "fixed",
          bottom: 20,
          right: 20,
          background: "#10b981",
          color: "white",
          padding: 10
        }}>
          {message}
        </div>
      )}

      {/* EDIT DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Application</DialogTitle>

        <DialogContent>

          <TextField fullWidth margin="dense" label="App Name"
            value={editApp?.app_name || ""}
            onChange={(e) => setEditApp({ ...editApp, app_name: e.target.value })}
          />

          {/* ✅ NEW CLIENT FIELD */}
          <TextField fullWidth margin="dense" label="Client"
            value={editApp?.client || ""}
            onChange={(e) => setEditApp({ ...editApp, client: e.target.value })}
          />

          <TextField fullWidth margin="dense" label="Module"
            value={editApp?.module || ""}
            onChange={(e) => setEditApp({ ...editApp, module: e.target.value })}
          />

          <Select fullWidth value={editApp?.environment || ""}
          onChange={(e) => setEditApp({ ...editApp, environment: e.target.value })}
            displayEmpty style={{ marginTop: 15 }}
          >
            <MenuItem value="">Select Env</MenuItem>
            <MenuItem value="DEV">DEV</MenuItem>
            <MenuItem value="UAT">UAT</MenuItem>
            <MenuItem value="PROD">PROD</MenuItem>
            <MenuItem value="DEMO">DEMO</MenuItem>
            <MenuItem value="POC">POC</MenuItem>
          </Select>

          <TextField fullWidth margin="dense" label="Repo"
            value={editApp?.repo_name || ""}
            onChange={(e) => setEditApp({ ...editApp, repo_name: e.target.value })}
          />

          <TextField fullWidth margin="dense" label="Developer"
            value={editApp?.developer || ""}
            onChange={(e) => setEditApp({ ...editApp, developer: e.target.value })}
          />

          <TextField fullWidth margin="dense" label="URL"
            value={editApp?.url || ""}
            onChange={(e) => setEditApp({ ...editApp, url: e.target.value })}
          />

          <TextField
  fullWidth
  margin="dense"
  label="Cloud"
  value={editApp?.cloud || ""}
onChange={(e) => setEditApp({ ...editApp, cloud: e.target.value })}
/>

          <TextField fullWidth margin="dense" label="Server"
            value={editApp?.server_name || ""}
            onChange={(e) => setEditApp({ ...editApp, server_name: e.target.value })}
          />

          <TextField fullWidth margin="dense" label="Pipeline"
            value={editApp?.jenkins_pipeline || ""}
            onChange={(e) => setEditApp({ ...editApp, jenkins_pipeline: e.target.value })}
          />

        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>Save</Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

